import styled from "styled-components";

export const HeaderContainer = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Primary,
}));

export const DineoutHeader = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    width: "100%",
    height: "100%",
}));
